import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ObjectUtils } from '../../../../utils/object.utils';

@Component({
    selector: 'popular-topics',
    templateUrl: './popular-topics.component.html',
    styleUrls: ['./popular-topics.component.scss']
})
export class PopularTopicsComponent implements OnChanges {
    public chartConfig = {
        spacingTop: 0,
        spacingRight: 0
    };

    public legend = {
        useHTML: true,
        y: 12,
        navigationActiveColor: '#445166',
        navigationInactiveColor: 'rgba(68,81,102,0.50)',
        navigationArrowSize: 10,
        width: 180,
        x: 102,
        align: 'center',
        floating: true
    };

    public overridenSeriesConfig = {
        size: '145px'
    };

    public overridenPiePlotOptions = {
        borderWidth: 0,
        center: [93, 75]
    };

    public readonly placeholderData = [
        {
            name: 'Fashion',
            y: 0.2,
            color: 'rgba(149,160,177, 0.1)',
            isPlaceholder: true
        },
        {
            name: 'Beauty',
            y: 0.2,
            color: 'rgba(149,160,177, 0.1)',
            isPlaceholder: true
        },
        {
            name: 'Home and Living',
            y: 0.2,
            color: 'rgba(149,160,177, 0.1)',
            isPlaceholder: true
        },
        {
            name: 'Food and Beverage',
            y: 0.2,
            color: 'rgba(149,160,177, 0.1)',
            isPlaceholder: true
        },
        {
            name: 'Others',
            y: 0.2,
            color: 'rgba(149,160,177, 0.1)',
            isPlaceholder: true
        }
    ];

    public drawnData: Array<object>;
    public hasNoData = true;

    @Input() popularTopic: Array<object>;
    @Input() isFetchingData: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.popularTopic) {
            const popularTopics = changes.popularTopic.currentValue;
            this.hasNoData = !Array.isArray(popularTopics) || popularTopics.length === 0;

            if (!this.hasNoData) {
                this.drawnData = this.enrichChartData(popularTopics);
            }
        }
    }

    private enrichChartData(source: any[]) {
        const results = ObjectUtils.deepClone(source);

        results.forEach(x => {
            x.labelMaxCharacterSize = 16;
        });

        return results;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/popular-topics/popular-topics.component.ts